export const ukPhoneRegex =
  /^(?:\+44\s?\(0\)\s?|\+44\s?|44\s?|0)[\d\s\-().]{9,13}$/;
